import { FormattedMessage } from 'react-intl';
import React from 'react';
import type { EmploymentEmployeeCategoryEnum } from 'app/types';

type RenderersType = {
  employeeCategory: EmploymentEmployeeCategoryEnum[];
};

const renderers = {
  employeeCategory: (value: RenderersType['employeeCategory']) => {
    return Array.isArray(value) ? (
      <table>
        <tbody>
          {value.map((item, index) => (
            <tr key={index}>
              <td>
                <FormattedMessage id={`employees.detail.employeeCategory.${item}`} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    ) : null;
  },
};

export default renderers;
